import { Heading } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'
import { VerifyChallenge } from '../../../src/component'
import { Route } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage, TerminalErrorCode } from '../../../src/model'
import { setCheckoutError, useAppDispatch, useAppRouter, useMobileLogin } from '../../../src/state'
import { useCheckoutSizes } from '../../../src/utils/responsive'
import { LoginHelpLink } from '../../../src/component/LoginHelpLink'
import { PageNames } from '../../../src/model/monitoring'

export const VerifyChallengePage: CheckoutPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const { headingSize } = useCheckoutSizes()
  const { dateOfBirthVerificationRequired, verifiedRoute } = useMobileLogin()
  const onError = (isMobileLoginVerification: boolean): void => {
    dispatch(
      setCheckoutError({
        error: isMobileLoginVerification ? TerminalErrorCode.MaxDobVerificationAttempts : TerminalErrorCode.MaxAttempts,
      })
    )
    router.push(Route.TERMINAL_ERROR)
  }

  const onSuccess = (): void => {
    if (dateOfBirthVerificationRequired && typeof verifiedRoute !== 'undefined') {
      router.push(verifiedRoute)
    } else {
      router.push(Route.CREATE_PASSWORD)
    }
  }

  useEffect(() => {
    router.prefetch(Route.TERMINAL_ERROR)
    router.prefetch(Route.CREATE_PASSWORD)
    router.prefetch(Route.ENTER_PASSWORD)
  }, [])

  return (
    <>
      <Heading size={headingSize}>{t('verifyChallenge:heading')}</Heading>
      <VerifyChallenge onSuccess={onSuccess} onError={onError} isMobileLoginVerification={dateOfBirthVerificationRequired} />
      <LoginHelpLink pageName={PageNames.DOB_LAST_NAME_VERIFY} />
      <TrackPageViewed pageName={dateOfBirthVerificationRequired ? PageNames.DOB_LAST_NAME_VERIFY : undefined} />
    </>
  )
}
